// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmojiStickersPanel__container-f25886 {
  width: 400px;
  height: 508px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  box-sizing: border-box;
}

.EmojiStickersPanel__tabs-d8e33f {
  display: flex;
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  width: 400px;\n  height: 508px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  padding-top: 12px;\n  box-sizing: border-box;\n}\n\n.tabs {\n  display: flex;\n  padding: 0 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EmojiStickersPanel__container-f25886`,
	"tabs": `EmojiStickersPanel__tabs-d8e33f`
};
module.exports = ___CSS_LOADER_EXPORT___;
